import axiosApi from "../axiosInstance";

const getMaintenanceList = async () => {
    try {
        const response = await axiosApi.get(`/Maintenance/getMaintenanceList`);
        return response?.data;
        
    } catch (error) {
        console.log("Error getLocationList===>:", error);
    }
};

const getMaintenanceDrop  = async () => {
    try {
        const response = await axiosApi.get(`/Maintenance/getMaintDrop`);
        return response?.data;
        
    } catch (error) {
        console.log("Error getLocationList===>:", error);
    }
};
const addMaintenance = async (body) => {
    try {
        const response = await axiosApi.post(`Maintenance/createMaint`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addLocation ===>", error);
    }
};
const getMaintenanceChecklist = async (Id, mainId) => {
    try {
        const response = await axiosApi.get(`Maintenance/getMaintCheckList/` + Id + "/" + mainId);
      
        return response?.data;

    } catch (error) {
        console.log("Error addLocation ===>", error);
    }
};
export const maintenanceService = {
    getMaintenanceList,
    addMaintenance,
    getMaintenanceDrop,
    getMaintenanceChecklist
}